export enum QrCodeVisibility {
  Hidden = 'visible',
  Visible = 'hidden',
}

export enum QrCodeSupportedDevice {
  Android = 'Android',
  iPhone = 'iPhone',
  iPad = 'iPad',
  BlackBerry = 'BlackBerry',
  OperaMini = 'Opera Mini',
  IEMobile = 'IEMobile',
}

export enum QrCodeScannerState {
  Successfull,
  Canceled,
}
